<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <a-row>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务名称：
            </a-col>
            <a-col :span="18">
              {{ data.task_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务类型：
            </a-col>
            <a-col :span="18">
              {{ data.task_type_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              药企：
            </a-col>
            <a-col :span="18">
              {{ data.company_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务期限：
            </a-col>
            <a-col :span="18">
              {{ data.time }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              反馈资料：
            </a-col>
            <a-col :span="18">
              {{ data.after_survey_name || "无" }}
            </a-col>
          </a-row>
        </a-col>
        <!-- <a-col :span="24">
          <a-row>
            <a-col :span="2">
              任务介绍：
            </a-col>
            <a-col :span="15">
              <a-textarea
                :value="data.content"
                :autosize="{ minRows: 2, maxRows: 6 }"
                disabled
              />
            </a-col>
          </a-row>
        </a-col> -->
        <a-col :span="24">
          <a-row>
            <a-col :span="2">
              任务要求：
            </a-col>
            <a-col :span="15">
              <a-textarea
                :value="data.require_desc"
                :autosize="{ minRows: 2, maxRows: 6 }"
                disabled
              />
            </a-col>
          </a-row>
        </a-col>

        <a-col :span="24">
          <a-row>
            <a-col :span="2">
              药企资料：
            </a-col>
            <a-col :span="15">
              <a-table
                :columns="columns1"
                :data-source="data.datas"
                size="small"
                :row-key="record => record.id"
                :pagination="false"
                bordered
              />
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-row>
            <a-col :span="2">
              推广员：
            </a-col>
            <a-col :span="20">
              <a-table
                :columns="columns2"
                :data-source="data.promoters"
                size="small"
                :row-key="record => record.tableId"
                :pagination="false"
                bordered
              >
                <a-checkbox
                  slot="check"
                  :indeterminate="indeterminate"
                  :checked="isCheckAll"
                  @change="checkAll"
                >
                  编号
                </a-checkbox>;
              </a-table>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <div class="btn-container">
        <a-button
          style="margin-right:20px"
          @click="onCancel"
        >
          返回
        </a-button>
        <a-button
          type="primary"
          :loading="btnIsLoading1"
          @click="onSubmit"
        >
          批量审核
        </a-button>
      </div>
    </div>

    <!--  -->
    <a-modal
      v-if="feedbackData"
      title="医生反馈"
      :visible="visible"
      ok-text=" "
      ok-type="link"
      @cancel="handleCancel"
    >
      <div class="feedbackwrapper">
        <a-row v-if="feedbackData.feedback.content">
          <a-col :span="6">
            任务反馈
          </a-col>
          <a-col :span="18">
            {{ feedbackData.feedback.content }}
          </a-col>
        </a-row>

        <a-row v-if="feedbackData.before_list.length>0">
          <a-col :span="6">
            调研报告
          </a-col>
          <a-col
            :span="18"
          >
            <div
              v-for="option in feedbackData.before_list"
              :key="option.id"
            >
              <div>{{ option.name }}</div>
              <div
                v-for="(item, index) in option.survey_list"
                :key="index"
              >
                <div>{{ index + 1 }}.{{ item.question }}</div>
                <div v-if="item.type != 0">
                  <div
                    v-for="(obj, ind) in item.option_str"
                    :key="ind"
                  >
                    <a-icon
                      v-if="obj.check == 0"
                      type="border"
                    />
                    <a-icon
                      v-if="obj.check == 1"
                      type="check-square"
                    />
                    {{ String.fromCharCode(65 + ind) }} {{ obj.option_title }}
                  </div>
                </div>
                <div v-if="item.type == 0">
                  文本回答：{{ item.option_str }}
                </div>
              </div>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="feedbackData.after_info.name">
          <a-col :span="6">
            会后调研a
          </a-col>
          <a-col :span="18">
            <div>{{ feedbackData.after_info.name }}</div>
            <div
              v-for="(item, index) in feedbackData.after_info.survey_list"
              :key="index"
            >
              <div>{{ index + 1 }}.{{ item.question }}</div>
              <div v-if="item.type != 0">
                <div
                  v-for="(obj, ind) in item.option_str"
                  :key="ind"
                >
                  <a-icon
                    v-if="obj.check == 0"
                    type="border"
                  />
                  <a-icon
                    v-if="obj.check == 1"
                    type="check-square"
                  />
                  {{ String.fromCharCode(65 + ind) }} {{ obj.option_title }}
                </div>
              </div>
              <div v-if="item.type == 0&&item.option_str!=''">
                文本回答：{{ item.option_str }}
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    attrs: {},
  };
  if(row.isMerge){
    obj.attrs.rowSpan  = row.rowSpan;
  }else{
    obj.attrs.rowSpan  = 0;
  }
  return obj;
};

const uuidv1 = require('uuid/v1');
import { formData } from './../data/index';
import RadioComponent from '../components/radio';
export default {
  components: { RadioComponent },
  data() {
    return {
      indeterminate: false,
      checkedList: [],
      plainOptions: [],
      isCheckAll: false,
      btnIsLoading1: false,
      // 蒙层
      visible: false,
      // 反馈数据
      feedbackData: '',

      // 分割线
      showData: [],
      columns1: [
        {
          title: '编号',
          dataIndex: 'post_id',
        },
        {
          title: '类型',
          dataIndex: 'obj_type_name',
        },
        {
          title: '标题',
          dataIndex: 'name',
        },
      ],
      columns2: [
        {
          dataIndex: 'id',
          width: 100,
          slots: { title: 'check'},
          customRender: (value, row, index) => {
            const obj = {
              children: null,
              attrs: {},
            };
            obj.children =
                <a-checkbox-group disabled ={row.task_status !== 3 }
                  options={[`${value}`]}
                  on-change={
                    (checkedList)=>{
                      console.log('data -> checkedList', checkedList);
                      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
                      this.isCheckAll = checkedList.length === this.plainOptions.length;
                    }
                  }
                  v-model={this.checkedList}
                />;
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
        {
          title: '推广员名称',
          dataIndex: 'user_realname',
          customRender: renderContent,
        },
        {
          title: '推广医生数量',
          dataIndex: 'doctor_num',
          customRender: renderContent,
        },
        {
          title: '推广员电话',
          dataIndex: 'mobile',
          customRender: renderContent,
        },
        {
          title: '医生',
          dataIndex: 'user_realname1',
        },
        {
          title: '观看资料次数',
          dataIndex: 'read_hits',
        },
        {
          title: '观看时长/秒',
          dataIndex: 'read_time',
        },
        {
          title: '查看反馈',
          dataIndex: '',
          customRender: (value, row, index) => {
            // console.log('哈哈哈',value,row,index)
            const obj = {
              children: row.rowSpan ? (
                <a-button
                  type="link"
                  on-click={() => {
                    let feedbackid = row.doctor_id;
                    // console.log('任务id',feedbackid)
                    this.getFeedBack(feedbackid);
                  }}
                >
                  查看
                </a-button>
              ) : (
                '暂无'
              ),
              attrs: {},
            };
            return obj;
          },
        },
        {
          title: '完成时间',
          dataIndex: 'sub_time',
          customRender: (value, row, index) => {
            const obj = {
              children: value !== 0 ? this.$Format(value) : '未完成',
              attrs: {},
            };
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
        {
          title: '状态',
          dataIndex: 'task_status',
          customRender: (value, row, index) => {
            const obj = {
              children: null,
              attrs: {},
            };

            if (value === 3) {
              obj.children = (
                <radio-component
                  isShow={this.showData[index]}
                  on-change={(e) => {
                    this.$set(this.showData, index, !this.showData[index]);
                    row.radioStatus = e.target.value;
                    console.log(
                      'data -> this.showData[index]',
                      this.showData[index]
                    );
                  }}
                  on-changeInput={(e) => {
                    row.reason = e.target.value;
                  }}
                ></radio-component>
              );
            } else {
              obj.children = row.task_status_name;
            }
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          customRender: (value, row, index) => {
            const obj = {
              children: null,
              attrs: {},
            };
            if (row.task_status === 3) {
              obj.children = (
                <a
                  href="javascript:;"
                  on-click={async() => {
                    let data = {
                      task_id: this.$route.query.id,
                      id: row.id,
                      task_status: row.radioStatus ? row.radioStatus : '5',
                      reason: row.reason,
                      scores: row.radioStatus === '4' ? '0' : row.scores,
                    };
                    let result = await this.$http.post('/task/checkOne', data);
                    if (result.data.status === 1) {
                      let result = await this.$http.post('/task/info', {
                        id: this.$route.query.id,
                      });
                      if (result.data.status === 1) {
                        let temp = result.data.data;
                        this.data = temp.info;
                        this.data.time=`${this.$Format(temp.info.start_time)} ~ ${this.$Format(temp.info.end_time)}`;
                        let promoters=[];
                        let num=0;
                        let isMerge=false;
                        let promoterId='';
                        temp.promoter_list.forEach((item, index)=>{
                          this.showData.push(false);
                          if(item.doctor_list.length>0){
                            item.doctor_list.forEach((list, listIndex)=>{
                              if(item.id!==promoterId){
                                promoterId=item.id;
                                isMerge=true;
                              }else{
                                isMerge=false;
                              }
                              promoters.push({...item, tableId: uuidv1(),
                                radioStatus: '5',
                                isMerge: isMerge,
                                user_realname1: list.user_realname,
                                read_time: list.read_time,
                                read_hits: list.read_hits,
                                rowSpan: item.doctor_list.length,
                                setRow: num++});
                            });
                          }else{
                            promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true});
                          }

                        });
                        this.data.promoters = promoters;
                        let result1 = await this.$http.post(
                          '/task/getTaskDatas',
                          { task_id: this.$route.query.id }
                        );
                        if (result1.data.status === 1) {
                          let data1 = result1.data.data.data_list;
                          this.$set(this.data, 'datas', data1);
                        }
                      }
                    }
                  }}
                >
                  提交
                </a>
              );
            } else {
              obj.children = '无';
            }
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
      ],
      data: {},
      btnIsLoading: false,
    };
  },
  async mounted() {
    // 获取数据
    this.getData({ id: this.$route.query.id });
  },
  methods: {
    //
    handleOk() {
      console.log('确定');
    },
    handleCancel() {
      this.visible = false;
      this.feedbackData = '';
    },
    // 获取反馈数据
    async getFeedBack(id) {
      let result = await this.$http.post('/task/getTaskDoctorFeedback', { id });
      if (result.data.status === 1) {
        this.visible = true;
        this.feedbackData = result.data.data;
        console.log(this.feedbackData);
      }
    },
    // 获取数据
    async getData(params) {
      let result = await this.$http.post('/task/info', params);
      if (result.data.status === 1) {
        let temp = result.data.data;
        this.data = temp.info;
        this.data.time=`${this.$Format(temp.info.start_time)} ~ ${this.$Format(temp.info.end_time)}`;
        let promoters=[];
        let num=0;
        let isMerge=false;
        let promoterId='';
        this.plainOptions=[];
        temp.promoter_list.forEach((item, index)=>{
          console.log('getData -> item', item);
          if(item.task_status===3){
            this.plainOptions.push(String(item.id));
          }
          console.log(' this.plainOptions', this.plainOptions);

          if(item.doctor_list.length>0){
            item.doctor_list.forEach((list, listIndex)=>{
              if(item.id!==promoterId){
                promoterId=item.id;
                isMerge=true;
              }else{
                isMerge=false;
              }
              this.showData.push(false);
              promoters.push({...item, tableId: uuidv1(),
                radioStatus: '5',
                isMerge: isMerge,
                user_realname1: list.user_realname,
                read_time: list.read_time,
                read_hits: list.read_hits,
                rowSpan: item.doctor_list.length,
                doctor_num: item.doctor_list.length,
                doctor_id: list.id,
                setRow: num++});
            });
          }else{
            this.showData.push(false);
            promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true, doctor_num: 0});
          }

          console.log('this.showData111', this.showData);
          console.log('promoters', promoters);
        });
        this.data.promoters = promoters;
        console.log('getData -> this.data.promoters', this.data.promoters);
        let result1 = await this.$http.post('/task/getTaskDatas', {
          task_id: this.$route.query.id,
        });
        if (result1.data.status === 1) {
          let data1 = result1.data.data.data_list;
          this.$set(this.data, 'datas', data1);
        }
      }
    },

    // 批量审核
    async onSubmit() {
      console.log('this.checkedList', this.checkedList);
      if(this.checkedList.length===0){
        this.$message.warning('请至少选择一项！');
        return;
      }
      let listData =[];
      this.checkedList.forEach((id)=>{
        console.log('onSubmit -> id', id);
        id=Number(id);
        listData.push(this.data.promoters.find((item)=>item.id===id));
      });
      console.log('listData', listData);
      let data={
        task_id: this.$route.query.id,
        ids: [],
        task_status: [],
        reason: [],
        scores: [],
      };
      listData.forEach((list)=>{
        data.ids.push(list.id);
        data.task_status.push(list.radioStatus);
        data.reason.push(list.reason);
        data.scores.push(list.scores);
      });
      this.btnIsLoading1 = true;
      console.log('data', data);
      let result=await this.$http.post('/task/checkPost', data);
      this.btnIsLoading1 = false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getData({ id: this.$route.query.id });
        this.checkedList=[];
        this.isCheckAll=false;
        this.indeterminate=false;
      }
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
    // 全选
    checkAll(e){
      console.log(' 222222this.plainOptions', this.plainOptions);
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
        isCheckAll: e.target.checked,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.article-edit-container {
  .ant-col-12 {
    margin-bottom: 30px;
  }
  .ant-col-24 {
    margin-bottom: 30px;
  }
  .btn-container {
    text-align: right;
    margin-top: 100px;
  }
  .feedbackwrapper{
    height: 500px;
    overflow: scroll;
  }
}
</style>
